// Gloabl Settings
export class Settings {
    public static showDebuggerConsole: boolean = false;

    public canPlaceAnyWhere: boolean = true;
    public trackUser: boolean = true;
    public shareUrl: string = "https://app.motes.dk/mote/";
    public placeholders = {
        profilePic: '../assets/images/placeholders/profilePic.jpg',
        mote: '../assets/images/placeholders/mote.png'
    };

    public fromJson(json: any): void {
        if(json.canPlaceAnyWhere) this.canPlaceAnyWhere = json.canPlaceAnyWhere;
        if(json.trackUser) this.trackUser = json.trackUser;
        if(json.shareUrl) this.shareUrl = json.shareUrl;
    }

    public toJson(settings: Settings): any {
        return {
            canPlaceAnyWhere: settings.canPlaceAnyWhere,
            trackUser: settings.trackUser,
            shareUrl: settings.shareUrl,
            placeholders: settings.placeholders,
            attributionControl: false
        }
    }
}
